import { makeStyles } from '@material-ui/core';
import { calculateHeight, em, px, vh } from '../common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

export const styles = makeStyles(theme => ({
  main: {
    fontSize: em(16),
    marginTop: '2.01vh',
    marginLeft: '1.24vw',
    width: '97.51vw',
    height: '95.96vh',
    backgroundColor: themeColor.lightBackground,
    outline: 0,
  },
  topArea: {
    fontSize: em(20),
    height: 'auto',
  },
  productLabel: {
    fontSize: px(20),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1px',
    paddingTop: '4.29vh',
    paddingLeft: '1.5vw',
    textTransform: 'uppercase',
  },
  displayButtons: {
    paddingTop: '2.34vh',
    paddingBottom: '2vh',
  },
  fullWidth: {
    width: '100%',
  },
  middleArea: {
    paddingLeft: '1.5vw',
    paddingRight: '0.94vw',
    overflowY: 'hidden',
    height: '100%',
  },
  bottomArea: {
    height: '9.44vh',
    paddingLeft: '1.5vw',
    paddingRight: '1.01vw',
    width: 'auto',
    bottom: '2.21vh',
  },
  productDisplayBottomLeftNavigation: {
    paddingRight: '1.17vw',
  },
  navigationLabel: {
    fontSize: vh(1.56),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1,
    letterSpacing: 0.7,
    color: theme.palette.info.dark,
    textAlign: 'center',
    '@media (max-height: 1080px)': {
      fontSize: calculateHeight(22, 1080).stringValue,
    },
    '@media (max-height: 768px)': {
      fontSize: vh(2.08),
    },
    '@media (max-height: 720px)': {
      fontSize: vh(2.08),
    },
  },
  navigationButton: {
    '& > button': {
      '& > span': {
        '& > svg': {
          '@media (max-height: 768px)': {
            fontSize: vh(2.6),
          },
          '@media (max-height: 720px)': {
            fontSize: vh(2.6),
          },
          '@media (max-height: 576px)': {
            fontSize: vh(2.6),
          },
        },
      },
      '@media (max-height: 768px)': {
        padding: 0,
        minWidth: 0,
      },
      '@media (max-height: 720px)': {
        minWidth: 0,
      },
    },
  },
  keypadButton: {
    minWidth: '7.29vh',
    width: '7.29vh',
    height: '7.29vh',
    borderRadius: '2px',
    boxShadow: `0 1px 3px 0 ${themeColor.almostwhite}`,
    '& > div': {
      color: themeColor.white,
    },
  },
  closeButton: {
    marginBottom: 0,
    width: '11.56vw',
    height: '7.29vh',
    borderRadius: 2,
    fontSize: vh(2.08),
    fontWeight: 500,
    letterspacing: 1.43,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.almostwhite}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
    '& .MuiTouchRipple-ripple': {
      color: `${theme.palette.secondary.main}`,
    },
  },
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  tareWeightTitleContainer: {
    height: '8.8vh',
  },
  tareWeightTitleBar: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  tareWeightTitleHeader: {
    color: themeColor.modalTitle,
  },
  tareWeightTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  tareWeightWeightLabel: {
    fontSize: vh(3.187250996015936),
    fontWeight: 500,
  },
  tareWeightTitleWeightContainer: {
    width: 'fit-content',
    height: 'fit-content',
    alignSelf: 'flex-end',
    marginRight: '2vh',
  },
  tareWeightContainer: {
    padding: 10,
  },
  priceLabel: {
    fontSize: vh(2.1248339973439574),
    fontWeight: 500,
  },
  priceLabelContainer: {
    height: 'fit-content',
    alignSelf: 'center',
  },
  underline: {
    '& > div.MuiInput-underline': {
      '&:before': {
        borderBottom: `0.398406374501992vh solid ${themeColor.borderGray}`,
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `1px solid ${themeColor.borderGray}`,
      },
      '&:after': {
        borderBottom: `0.5312084993359893vh solid ${theme.palette.secondary.main}`,
      },
    },
  },
  inputTextField: {
    width: '30vw',
    '& > label': {
      fontWeight: 500,
      color: themeColor.defaultTextColor,
    },
    '& > label.Mui-focused.MuiInputLabel-shrink': {
      color: theme.palette.secondary.main,
    },
  },
  greyUnderline: {
    borderBottom: `1px solid ${themeColor.borderGray}`,
  },
  parentInputContainer: {
    flex: 1,
  },
  parentManualTareinputContainer: {
    width: '50%',
    height: '25vh',
    marginTop: '4vh',
  },
  inputTextFieldUnderline: {
    paddingLeft: 10,
    fontSize: vh(1.85),
    fontWeight: 400,
    color: themeColor.defaultTextColor,
  },
  inputContainerPercentage: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonClass: {
    alignSelf: 'flex-end',
  },
  cancelButton: {
    fontSize: vh(2.1248),
    marginRight: '1.3280vh',
  },
  approveButton: {
    fontSize: vh(2.1248),
  },
  tareWeightContainerScreen: {
    flex: 1,
  },
  tareWeightTitleLayout: {
    height: 'fit-content',
    marginLeft: '2vh',
  },
  '& label.Mui-focused': {
    color: theme.palette.secondary.main,
  },
  tareWeightBackground: {
    display: 'flex',
    flexwrap: 'wrap',
  },
  marginSeparator: {
    marginBottom: '2vh',
  },
  tareWeightForms: {
    alignSelf: 'flex-end',
  },
  noLinkedTareManualTareinputContainer: {
    width: '50%',
    marginTop: '4vh',
    height: '20vh',
  },
  noLinkedTareContainer: {
    flex: 1,
    height: '40vh',
  },
}));
